import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/utilities";

const initialState = {
  token: undefined,
  userId: undefined,
  error: undefined,
  loading: false,
  authRedirectPath: "/",
  success: false,
};

const authStart = (state, action) => {
  return updateObject(state, { error: undefined, loading: true });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    token: action.token,
    userId: action.userId,
    error: undefined,
    loading: false,
  });
};

const authFail = (state, action) => {
  return updateObject(state, {
    error: action.error[0].message,
    token: undefined,
    loading: false,
  });
};
const signUpSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: undefined,
    success: true,
  });
};
const authLogout = (state, action) => {
  return updateObject(state, { token: undefined, userId: undefined });
};

const setAuthRedirectPath = (state, action) => {
  return updateObject(state, { authRedirectPath: action.path });
};

const toggleTempStart = (state, action) => {
  return updateObject(state, { error: undefined, loading: true });
};
const toggleTempSuccess = (state, action) => {
  return updateObject(state, {
    error: undefined,
    loading: false,
    successMessage: `Temprature has been changes to ${action.data.temperatureUnit} successfully`,
  });
};

const toggleTempFail = (state, action) => {
  return updateObject(state, {
    error: action.error[0].message,
    token: undefined,
    loading: false,
  });
};

const getTempStatusStart = (state, action) => {
  return updateObject(state, { error: undefined, loading: true });
};
const getTempStatusSuccess = (state, action) => {
  return updateObject(state, {
    error: undefined,
    loading: false,
    temperatureUnit: action.data.temperatureUnit,
    voiceCall: action.data.voiceCall,
  });
};

const getTempStatusFail = (state, action) => {
  return updateObject(state, {
    error: action.error[0].message,
    token: undefined,
    loading: false,
  });
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.SET_AUTH_REDIRECT_PATH:
      return setAuthRedirectPath(state, action);
    case actionTypes.SINGUP_SUCCESS:
      return signUpSuccess(state, action);
    case actionTypes.TOGGLE_TEMP_START:
      return toggleTempStart(state, action);
    case actionTypes.TOGGLE_TEMP_SUCCESS:
      return toggleTempSuccess(state, action);
    case actionTypes.TOGGLE_TEMP_FAIL:
      return toggleTempFail(state, action);
    case actionTypes.GET_TEMP_STATUS_START:
      return getTempStatusStart(state, action);
    case actionTypes.GET_TEMP_STATUS_SUCCESS:
      return getTempStatusSuccess(state, action);
    case actionTypes.GET_TEMP_STATUS_FAIL:
      return getTempStatusFail(state, action);
    default:
      return state;
  }
};

export default auth;
